"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const icon_1 = __importDefault(require("../icon/icon"));
const modal_1 = __importDefault(require("../modal/modal"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const ticketTable_1 = __importDefault(require("./ticketTable"));
const ticketForm_1 = __importDefault(require("./ticketForm"));
const paginatedMessageComponent_1 = __importDefault(require("../messageComponent/paginatedMessageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const eventConstants_1 = require("../../constants/eventConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const ticketSlice_1 = require("../../features/ticket/ticketSlice");
const TicketsModal = ({ visible, hideModal, onPageChange }) => {
    const dispatch = useAppDispatch_1.default();
    const { ticketCount, selectedTicket } = useAppSelector_1.default((state) => ({
        ticketCount: state.ticket.totalEntries,
        selectedTicket: state.ticket.selectedTicket,
    }));
    const [showTicketDetails, setShowTicketDetails] = react_1.useState(false);
    const showSelectedTicketDetails = ({ ticket }) => {
        dispatch(ticketSlice_1.setSelectedTicket(ticket));
        setShowTicketDetails(true);
    };
    return (react_1.default.createElement(modal_1.default, { title: "Tickets", visible: visible, hideModal: hideModal, containerStyle: styles_1.default.modelFormTop },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.modalWidth },
            showTicketDetails && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionColumn },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.alignRight },
                    react_1.default.createElement(pressable_1.default, { onPress: () => setShowTicketDetails(false), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.TOGGLE_VIEW_USER_TICKETS },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                            react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Go back `)))),
                react_1.default.createElement(ticketForm_1.default, { ticket: selectedTicket, readonly: !!selectedTicket }))),
            !showTicketDetails && ticketCount !== 0 && (react_1.default.createElement(ticketTable_1.default, { onTicketPress: showSelectedTicketDetails, onPageChange: onPageChange })),
            !showTicketDetails && ticketCount === 0 && (react_1.default.createElement(paginatedMessageComponent_1.default, { message: "No Tickets Found.", color: colors_1.default.BLUE, icon: free_solid_svg_icons_1.faSadTear })))));
};
exports.default = TicketsModal;
